import httpService from '@/modules/common/services/httpService';
import gatewayService from '@/modules/common/services/gatewayService';

const paymentSettingsRoute = '/platform/v1/payment/settings';
const paymentGatewaysRoute = '/v3/payment_processing/payment_gateways';

const fetchSettings = async () => httpService.get(paymentSettingsRoute).then((res) => res.data?.data?.payment_settings);
const saveSettings = async (payload) => httpService.post(paymentSettingsRoute, payload).then((res) => res.data.data);
const updateDefaultCurrency = async () => httpService.put(`${paymentSettingsRoute}/update_default_currency`, {}).then((res) => res.data.data);
const fetchPaymentGatewaysSettings = async (gatewayName) => gatewayService.get(paymentGatewaysRoute, { gateway_name: gatewayName }).then((res) => res.data);

export default {
  fetchSettings,
  saveSettings,
  updateDefaultCurrency,
  fetchPaymentGatewaysSettings,
};
